import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=7e3c3fe3&"
import script from "./DropdownDivider.vue?vue&type=script&lang=js&"
export * from "./DropdownDivider.vue?vue&type=script&lang=js&"
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports